import 'bootstrap/dist/css/bootstrap.min.css'; 
import '../assets/css/DesignSection.css'
import Roll from 'react-reveal/Roll';


function DesignSection(props) {
    return (
            <Roll left className="DS">  
                <div className="col-12 col-lg-4 col-md-6 col-sm-6 pros1 ">
                  <div className="border">
                  <h3>Day {props.indx}</h3> 
                  <h6>{props.title}</h6> 
                  </div>
                  <img src={props.url} alt="line"  />
                </div>
            </Roll>
        );
    }
    
export default DesignSection;